export interface TrackerTile {
  label: string;
  value: string;
  sub: string;
  /** text-success or text-danger, on both the value and the line under it. */
  tone?: string;
}

/** The headline figures, five across, two to a row on a phone. */
export function TrackerTiles({ tiles }: { tiles: TrackerTile[] }) {
  return (
    <div className="tracker-tiles">
      {tiles.map((tile) => (
        <div key={tile.label} className="tracker-tile">
          <div className="tracker-eyebrow">{tile.label}</div>
          <div className={`tracker-tile-value ${tile.tone ?? ""}`}>{tile.value}</div>
          <div className={`tracker-tile-sub ${tile.tone ?? ""}`}>{tile.sub}</div>
        </div>
      ))}
    </div>
  );
}
